import React from "react";
import {useNavigate} from "react-router-dom";
import "./CourseCard.scss";

const CourseCard = ({ id, image, title, description, videos, videosWatched }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/courses/${id}`);
  };

  return (
    <div className="course-card" onClick={handleClick}>
      <div className="course-card-image">
        <img src={image} alt={title} />
      </div>
      <div className="course-card-content">
        <h3>{title}</h3>
        <p className="description">
          {description ? (
            description.length > 120 ? `${description.substring(0, 120)}...` : description
          ) : (
            "No description available"
          )}
        </p>
        <p className="video-count">
            <span>{videosWatched} / {videos} Videos</span>
        </p>
      </div>
    </div>
  );
};

export default CourseCard;